import util from "@/libs/util";
import {httpClient,basicsHttp} from "./_http";

/**
 * @desc 获取港口列表
 */

const post = (url, payload, opts = {}) =>
 httpClient.post(url, payload, {
     baseURL: '/api/customer-server'
});

export const fetchPortList = (payload = {}) => {
  return httpClient.get("/data/port", {
    ...payload,
  });
};

export const fetchPortListActive = (payload = '') => {
  return httpClient.get("/data/port/active", {
    ...payload,
  });
};

export const fetchPortListSearch = (payload = '') => {
  return basicsHttp.get(`/query/data/port/composite/search?tags=${payload}&needCompositeName=false`, {});
};

export const getPortList = (payload = {}) => {
  return httpClient.get("/common/findPort/list", {
    ...payload,
  });
};

export const findPortDistrict = (payload) => {
  return httpClient.post("/standardPrice/findPortDistrict", payload)
}

// export const getChargeInfo = (payload) => {
//   return httpClient.get("/standardPrice/getChargeInfo", { params: payload })
// }

export const getChargeInfo = (payload) => {
  return util.ajax_get_pro(null, "/harbour-server/standardPrice/getChargeInfo", payload)
}

// 查询多地装价格（老）
export const selectPortDistrict = (payload) => {
  return httpClient.post("/standardPrice/selectPortDistrict", payload)
}
// 查询多地装价格
export const queryMutilDoorLoadPrice = (payload) => {
  return httpClient.post("/standardPrice/queryMutilDoorLoadPrice", payload)
}

export const selectPortDistrictByCharge = (payload) => {
  return httpClient.post("/standardPrice/selectPortDistrictByCharge", payload)
}

export const selectOverWeight = (payload) => {
  return httpClient.post("/standardPrice/selectOverWeight", payload)
}

export const selectOverWeightNew = (payload) => {
  return httpClient.post("/standardPrice/selectOverWeightNew", payload)
}

export const selectDistanceDetour = (payload) => {
  return httpClient.post("/standardPrice/selectDistanceDetour", payload)
}
export const addSalesmanTask = (payload) => {
  return httpClient.post("/standard-price-task/add-salesman-task", payload)
}



export const selectPortCoordinate = (payload) => {
  return httpClient.post("/standardPrice/getPortLocation", payload)
}


export const queryportDistricts = (payload) => {
  return httpClient.get("/standardPrice/pricing-port-district/select", { params: payload })
}

export const addSearchFailedLog = (payload) => {
  return httpClient.post("/standardPrice/addSearchFailedLog", payload)
}

export const getweightSectionList = () => {
  return post("/common/port-weight", {
    meta: {
      code: "XXR1804201034",
      client: "H5",
      tag: "",
      time: 1524191802069
    }
  })
}


export const queryContractAndStandardPriceMsg = (payload) => {
  return httpClient.post("/../customer-server/customs-declaration-contract-price/query-contract-and-standard-price-msg", payload)
}

export const queryContractOrStandardPriceMsg = (payload) => {
  return httpClient.post("/../customer-server/customs-declaration-contract-price/query-contract-or-standard-price-msg", payload)
}

export const queryPrice = (payload) => {
  return post("/mini/getPriceNew", payload)
}
export const getDispose = (payload) => {
  return httpClient.get("/../customer-server/declare/dispose", { params: payload })
}
export const getIsBusySeason = (payload) => {
  return httpClient.post("/../customer-server/busy-season-setting/select/todayinbusySeanson", payload)
}

export const arrivalTime = (payload) => {
  return httpClient.post("/busy-season/check/quota/rule", payload)
}
export const updateArrivalTime = (payload) => {
  return httpClient.post("/../customer-server/truck-order-container/plan-arrival-time/update", payload)
}

// 保存快照
export const saveSnapshot = (payload) => {
  return post('/search-price/save/snapshot', payload);
}
// 查询快照
export const querySnapshot = (payload) => {
    return post('search-price/query/snapshot', payload);
}
// 生成报价
export const saveQuote = (payload) => {
    return post('search-price/save/quote', payload);
}
export const getBoxMakingDistance = (payload) => {
  return util.ajax_post_pro(null, "/harbour-server/busy-season/calc-distance", payload)
}


// WEBPACK FOOTER //
// ./src/api/data.js